export default __webpack_public_path__ + "assets/images/turtle-yellow-c0e015737e9f70b3b037996659cba6a9.svg";